<template>
  <div>
    <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="expireTimeOption" @change="onChangeTime">></el-date-picker>
    <div class="salesH">
      <p>
        <span>{{ headerData.allPackageSaleCount }}</span>
        <samp>套餐销售总数</samp>
      </p>
      <p>
        <span>{{ headerData.fansSaleCount }}</span>
        <samp>粉丝端购买总数</samp>
      </p>
      <p>
        <span>{{ headerData.appSaleCount }}</span>
        <samp>店员端销售总数量</samp>
      </p>
      <p>
        <span>{{ headerData.pcSaleCount }}</span>
        <samp>电脑端销售总数量</samp>
      </p>
      <!-- <p>
                <span>{{headerData.smartBoxSaleCount}}</span>
                <samp>Smart box销售总数量</samp>
            </p> -->
    </div>
    <div class="btnL">
      <el-button type="primary" @click="onDownload">导出报表</el-button>
      <el-button type="primary" @click="onPrint">打印报表</el-button>
    </div>
    <el-table tooltip-effect="light" :data="tableData" style="width: 100%;margin-bottom: 58px;" @sort-change="sortChange">
      <el-table-column type="index" width="50" label="排名">
        <template slot-scope="scope">
          {{ scope.$index*1+1 + (pageNum*1-1)*10 }}
        </template>
      </el-table-column>
      <el-table-column prop="vipCardName" label="套餐名称" width="140">
        <template slot-scope="scope">
          <el-popover v-if="(scope.row.status == -1) || (scope.row.status == 1)" placement="bottom-start" trigger="hover">
            <p style="padding: 10px;">{{ scope.row.status == -1 ? '该套餐已删除' : '该套餐已停售' }}</p>
            <img v-if="scope.row.status == -1" slot="reference" class="commonTextIcon" src="static/images/icon/icon_del.png" />
            <img v-else slot="reference" class="commonTextIcon" src="static/images/icon/icon_stop.png" />
          </el-popover>
          <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
            <div slot="content">
              <p>{{ scope.row.vipCardName }}</p>
            </div>
            <span class="commonTableShow" :style="((scope.row.status == -1) || (scope.row.status == 1)) ? 'width: 100px;' : 'width: 120px;'" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.vipCardName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="vipCardPrice" label="套餐原价(元)"></el-table-column>
      <el-table-column prop="fansSaleCount" sortable label="粉丝端购买数量"></el-table-column>
      <el-table-column prop="appSaleCount" sortable label="店员端销售数量"></el-table-column>
      <el-table-column prop="pcSaleCount" sortable label="电脑端销售数量"></el-table-column>
      <!-- <el-table-column prop="smartBoxSaleCount" sortable label="Smart box销售数量"></el-table-column> -->
      <el-table-column prop="allPackageSaleCount" sortable label="套餐销售数量"></el-table-column>
      <el-table-column prop="saleAmount" sortable>
        <template slot="header" slot-scope="scope">
          <span v-show="scope">套餐销售总金额(元)</span>
          <el-tooltip placement="top-start" width="200" trigger="hover" effect="light">
            <div slot="content">
              <p class="tooltip-p">套餐的实收金额统计</p>
            </div>
            <i class="iconfont iconCdThree">&#xe71a;</i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="tableData.length > 0" class="allFooter">
      <el-pagination background :current-page.sync="pageNum" :page-size="pageSize" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import {
  getVipCardSaleDetailMsg, // (5.2)套餐销售(上面的总数量)
  getVipCardSaleDetailPage, // (5.2)套餐销售（下面的分页数量）
} from '../api';

export default {
  data() {
    return {
      time: [
        dayjs()
          .subtract(30, 'day')
          .format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      tableData: [],
      pageNum: 1,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
      sortKeyWord: 0,
      sortType: 0,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      headerData: {},
      tooltipStatus: false, // 气泡显示
    };
  },
  activated() {
    this.getData();
    this.getTableData(1);
  },
  methods: {
    // 获取套餐数据
    getData() {
      const data = {
        startTime: this.time[0],
        endTime: this.time[1],
        mainId: sessionStorage.getItem('mainId')
      };
      getVipCardSaleDetailMsg(data).then((res) => {
        this.headerData = res.data ? res.data : {};
      });
    },
    // 排序
    sortChange({ column, prop, order }) {
      if (!column && !prop && !order) {
        this.sortKeyWord = 0;
        this.sortType = 0;
      } else {
        if (order === 'descending') {
          this.sortType = 0;
        } else {
          this.sortType = 1;
        }
        if (prop === 'saleAmount') {
          this.sortKeyWord = 0;
        } else if (prop === 'allPackageSaleCount') {
          this.sortKeyWord = 1;
        } else if (prop === 'fansSaleCount') {
          this.sortKeyWord = 2;
        } else if (prop === 'appSaleCount') {
          this.sortKeyWord = 3;
        } else if (prop === 'pcSaleCount') {
          this.sortKeyWord = 4;
        } else if (prop === 'smartBoxSaleCount') {
          this.sortKeyWord = 5;
        }
      }
      this.getTableData();
    },
    // 获取表格数据
    getTableData(val) {
      const data = {
        startTime: this.time ? this.time[0] : null,
        endTime: this.time ? this.time[1] : null,
        mainId: sessionStorage.getItem('mainId'),
        pageNum: val,
        pageSize: this.pageSize,
        sortKeyWord: this.sortKeyWord,
        sortType: this.sortType
      };
      getVipCardSaleDetailPage(data).then((res) => {
        this.tableData = res.data ? res.data.records ? res.data.records : [] : [];
        this.rowCount = res.data.total;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getTableData(1);
    },
    handleCurrentChange(val) {
      this.getTableData(val);
    },
    // 修改日期
    onChangeTime() {
      this.getData();
      this.getTableData(1);
    },
    // 导出表格
    onDownload() {
      this.$root.$children[0].fatherExport('exportVipCardSaleDetailPage', this.time[0], this.time[1], this.sortKeyWord, this.sortType);
    },
    // 网页打印
    onPrint() {
      this.$print({
        data: this.tableData,
        table_tol: [
          {
            prop: 'vipCardName',
            name: '套餐名称'
          },
          {
            prop: 'vipCardPrice',
            name: '套餐价格(元)'
          },
          {
            prop: 'fansSaleCount',
            name: '粉丝端购买数量'
          },
          {
            prop: 'appSaleCount',
            name: '店员端销售数量'
          },
          {
            prop: 'pcSaleCount',
            name: '电脑端销售数量'
          },
          // {
          //   prop: 'smartBoxSaleCount',
          //   name: 'Smart box销售数量'
          // },
          {
            prop: 'allPackageSaleCount',
            name: '套餐销售数量'
          },
          {
            prop: 'saleAmount',
            name: '套餐销售总金额(元)'
          }
        ],
        title: '套餐销售'
      });
    }
  }
};
</script>
<style lang="less" scoped>
.salesH {
    border: 1px solid rgba(230, 235, 245, 1);
    margin-top: 20px;
    padding: 20px 0;
    display: flex;
    p {
        flex: 1;
        span {
            text-align: center;
            display: block;
            font-size: 36px;
        }
        samp {
            text-align: center;
            display: block;
            font-size: 16px;
            color: #333333;
        }
    }
    p:nth-child(1) {
        border-right: 1px solid #e6ebf5;
    }
}
.btnL {
    margin: 20px 0;
    float: right;
}
</style>
